import { NeoBrandsData } from "../MyReferralPage/MyReferralRedeemnow";
import React, { useState } from "react";
import { PageHeader } from "components/ui";

const RedeemPage = () => {
  // State to manage active tab
  const [activeTab] = useState("rewards");

  return (
    <div className="zs-page zs-page-medium">
      <PageHeader
        eyebrow="Rewards"
        title="Redeem your points"
        subtitle="Pick a gift card, confirm your contact details, then verify the request with a one-time code."
      />
      {activeTab === "rewards" && <NeoBrandsData />}
    </div>
  );
};

export default RedeemPage;
